"use client";

import { c as _c } from "react/compiler-runtime";
import MediaTypeBadge from "@/components/drops/media/MediaTypeBadge";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import { MobileVotingModal, VotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import { DropLocation } from "@/components/waves/drops/Drop";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropActionsOptions from "@/components/waves/drops/WaveDropActionsOptions";
import WaveDropMobileMenuDelete from "@/components/waves/drops/WaveDropMobileMenuDelete";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { ImageScale } from "@/helpers/image.helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { startDropOpen } from "@/utils/monitoring/dropOpenTiming";
import Link from "next/link";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import MemeDropTraits from "./MemeDropTraits";
import MemesLeaderboardDropArtistInfo from "./MemesLeaderboardDropArtistInfo";
import MemesLeaderboardDropCard from "./MemesLeaderboardDropCard";
import MemesLeaderboardDropDescription from "./MemesLeaderboardDropDescription";
import MemesLeaderboardDropHeader from "./MemesLeaderboardDropHeader";
import MemesLeaderboardDropVoteSummary from "./MemesLeaderboardDropVoteSummary";
interface MemesLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly location?: DropLocation | undefined;
}
export const MemesLeaderboardDrop: React.FC<MemesLeaderboardDropProps> = t0 => {
  const $ = _c(102);
  const {
    drop,
    onDropClick,
    location: t1
  } = t0;
  const location = t1 === undefined ? DropLocation.WAVE : t1;
  const isMobileScreen = useIsMobileScreen();
  const isTabletOrSmaller = useMediaQuery("(max-width: 1023px)");
  const {
    canDelete
  } = useDropInteractionRules(drop);
  const [isVotingModalOpen, setIsVotingModalOpen] = useState(false);
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let mediaImageScale = ImageScale.AUTOx800;
  if (isMobileScreen) {
    mediaImageScale = ImageScale.AUTOx450;
  } else {
    if (isTabletOrSmaller) {
      mediaImageScale = ImageScale.AUTOx600;
    }
  }
  let t2;
  if ($[0] !== hasTouchScreen) {
    t2 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t2);
  const title = drop.metadata.find(_temp)?.data_value ?? "Artwork Title";
  const description = drop.metadata.find(_temp2)?.data_value ?? "This is an artwork submission for The Memes collection.";
  let t3;
  if ($[2] !== drop.parts) {
    t3 = drop.parts.at(0)?.media.at(0);
    $[2] = drop.parts;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const artworkMedia = t3;
  let t4;
  if ($[4] !== drop.top_raters) {
    t4 = drop.top_raters.slice(0, 3);
    $[4] = drop.top_raters;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const firstThreeVoters = t4;
  let t5;
  if ($[6] !== drop || $[7] !== hasTouchScreen || $[8] !== isMobileScreen || $[9] !== onDropClick) {
    t5 = () => {
      if (hasTouchScreen) {
        return;
      }
      startDropOpen({
        dropId: drop.id,
        waveId: drop.wave.id,
        source: "leaderboard_memes",
        isMobile: isMobileScreen
      });
      onDropClick(drop);
    };
    $[6] = drop;
    $[7] = hasTouchScreen;
    $[8] = isMobileScreen;
    $[9] = onDropClick;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== drop) {
    t6 = <MemesLeaderboardDropArtistInfo drop={drop} />;
    $[11] = drop;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== canDelete || $[14] !== drop || $[15] !== hasTouchScreen) {
    t7 = !hasTouchScreen && <><WaveDropActionsOpen drop={drop} />{canDelete && <WaveDropActionsOptions drop={drop} />}</>;
    $[13] = canDelete;
    $[14] = drop;
    $[15] = hasTouchScreen;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <div className="tw-flex tw-gap-2 tw-text-iron-400">{t7}</div>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t8) {
    t9 = <div className="tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-white/5 tw-bg-iron-900/30 tw-p-4 tw-pb-3"><div className="tw-flex tw-items-start tw-justify-between tw-gap-4">{t6}{t8}</div></div>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const t10 = artworkMedia?.mime_type;
  let t11;
  if ($[22] !== drop.id || $[23] !== t10) {
    t11 = <MediaTypeBadge mimeType={t10} dropId={drop.id} size="sm" />;
    $[22] = drop.id;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== title) {
    t12 = <MemesLeaderboardDropHeader title={title} />;
    $[25] = title;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12) {
    t13 = <div className="tw-flex tw-items-center tw-gap-2">{t11}{t12}</div>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== description) {
    t14 = <MemesLeaderboardDropDescription description={description} />;
    $[30] = description;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = <div className="tw-px-4 tw-pb-4 tw-pt-4"><div className="tw-space-y-1">{t13}{t14}</div></div>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== artworkMedia || $[36] !== location || $[37] !== mediaImageScale) {
    t16 = artworkMedia && <div className={`tw-flex tw-h-96 tw-justify-center ${location === DropLocation.WAVE ? "tw-bg-iron-950" : "tw-bg-iron-900/40"}`}><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} imageScale={mediaImageScale} /></div>;
    $[35] = artworkMedia;
    $[36] = location;
    $[37] = mediaImageScale;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== drop) {
    t17 = <MemeDropTraits drop={drop} />;
    $[39] = drop;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== drop.context_profile_context || $[42] !== drop.raters_count || $[43] !== drop.rating || $[44] !== drop.rating_prediction || $[45] !== drop.wave.voting_credit_type || $[46] !== firstThreeVoters) {
    t18 = <MemesLeaderboardDropVoteSummary current={drop.rating} projected={drop.rating_prediction} creditType={drop.wave.voting_credit_type} ratersCount={drop.raters_count} topVoters={firstThreeVoters} userContext={drop.context_profile_context} />;
    $[41] = drop.context_profile_context;
    $[42] = drop.raters_count;
    $[43] = drop.rating;
    $[44] = drop.rating_prediction;
    $[45] = drop.wave.voting_credit_type;
    $[46] = firstThreeVoters;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== firstThreeVoters) {
    t19 = firstThreeVoters.map(_temp5);
    $[48] = firstThreeVoters;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t19) {
    t20 = <div className="tw-flex tw-items-center -tw-space-x-2">{t19}</div>;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== drop.raters_count) {
    t21 = formatNumberWithCommas(drop.raters_count);
    $[52] = drop.raters_count;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  const t22 = drop.raters_count === 1 ? "voter" : "voters";
  let t23;
  if ($[54] !== t22) {
    t23 = <span className="tw-font-normal tw-text-iron-500">{t22}</span>;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== t21 || $[57] !== t23) {
    t24 = <span className="tw-text-xs tw-font-bold tw-text-white">{t21}{" "}{t23}</span>;
    $[56] = t21;
    $[57] = t23;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] !== t20 || $[60] !== t24) {
    t25 = <div className="tw-flex tw-items-center tw-gap-2 @[700px]:tw-hidden">{t20}{t24}</div>;
    $[59] = t20;
    $[60] = t24;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = () => setIsVotingModalOpen(true);
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== drop) {
    t27 = <VotingModalButton drop={drop} onClick={t26} />;
    $[63] = drop;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== t25 || $[66] !== t27) {
    t28 = <div className="tw-flex tw-w-full tw-flex-shrink-0 tw-items-center tw-justify-between tw-gap-4 @[700px]:tw-w-auto @[700px]:tw-justify-end" onClick={_temp3}>{t25}{t27}</div>;
    $[65] = t25;
    $[66] = t27;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== t18 || $[69] !== t28) {
    t29 = <div className="tw-flex tw-flex-col tw-justify-between tw-gap-4 @[700px]:tw-flex-row @[700px]:tw-items-center">{t18}{t28}</div>;
    $[68] = t18;
    $[69] = t28;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  let t30;
  if ($[71] !== t17 || $[72] !== t29) {
    t30 = <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-y-4 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/5 tw-bg-iron-900/30 tw-p-4">{t17}{t29}</div>;
    $[71] = t17;
    $[72] = t29;
    $[73] = t30;
  } else {
    t30 = $[73];
  }
  let t31;
  if ($[74] !== t15 || $[75] !== t16 || $[76] !== t30 || $[77] !== t9) {
    t31 = <div>{t9}{t15}{t16}{t30}</div>;
    $[74] = t15;
    $[75] = t16;
    $[76] = t30;
    $[77] = t9;
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  let t32;
  if ($[79] !== drop || $[80] !== isMobileScreen || $[81] !== isVotingModalOpen) {
    t32 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} />;
    $[79] = drop;
    $[80] = isMobileScreen;
    $[81] = isVotingModalOpen;
    $[82] = t32;
  } else {
    t32 = $[82];
  }
  let t33;
  if ($[83] !== drop || $[84] !== t31 || $[85] !== t32) {
    t33 = <MemesLeaderboardDropCard drop={drop}>{t31}{t32}</MemesLeaderboardDropCard>;
    $[83] = drop;
    $[84] = t31;
    $[85] = t32;
    $[86] = t33;
  } else {
    t33 = $[86];
  }
  let t34;
  if ($[87] !== t33 || $[88] !== touchHandlers) {
    t34 = <div {...touchHandlers}>{t33}</div>;
    $[87] = t33;
    $[88] = touchHandlers;
    $[89] = t34;
  } else {
    t34 = $[89];
  }
  let t35;
  if ($[90] !== canDelete || $[91] !== drop || $[92] !== hasTouchScreen || $[93] !== isActive || $[94] !== setIsActive) {
    t35 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={drop} onOpenChange={() => setIsActive(false)} />{canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={() => setIsActive(false)} />}</div></CommonDropdownItemsMobileWrapper>, document.body);
    $[90] = canDelete;
    $[91] = drop;
    $[92] = hasTouchScreen;
    $[93] = isActive;
    $[94] = setIsActive;
    $[95] = t35;
  } else {
    t35 = $[95];
  }
  let t36;
  if ($[96] !== t34 || $[97] !== t35) {
    t36 = <div className="tw-group tw-w-full">{t34}{t35}</div>;
    $[96] = t34;
    $[97] = t35;
    $[98] = t36;
  } else {
    t36 = $[98];
  }
  let t37;
  if ($[99] !== t36 || $[100] !== t5) {
    t37 = <div className="tw-w-full tw-cursor-pointer tw-@container" onClick={t5}>{t36}</div>;
    $[99] = t36;
    $[100] = t5;
    $[101] = t37;
  } else {
    t37 = $[101];
  }
  return t37;
};
function _temp(m) {
  return m.data_key === "title";
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp3(e) {
  return e.stopPropagation();
}
function _temp4(e_0) {
  return e_0.stopPropagation();
}
function _temp5(voter) {
  return <Link key={voter.profile.handle ?? voter.profile.primary_address} href={`/${voter.profile.handle ?? voter.profile.primary_address}`} onClick={_temp4}>{voter.profile.pfp ? <img className="tw-h-6 tw-w-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={voter.profile.pfp} alt="Recent voter" /> : <div className="tw-h-6 tw-w-6 tw-rounded-lg tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />}</Link>;
}